export default [

    {
        path: '',
        name: 'vendas-whats-midias',
        redirect: { name: 'vendas-whats-midias-home' },
    },

    {
        path: 'home',
        name: 'vendas-whats-midias-home',
        component: () => import('@/aplicacao/modulos/vendas-whats-midias/_Home'),
        meta: { autenticacao: true, permissao: 'ROLE_VENDAS_VIA_WHATSAPP_E_MIDIAS_SOCIAIS' },
    },

    {
        path: 'historico',
        name: 'vendas-whats-midias-historico',
        component: () => import('@/aplicacao/modulos/vendas-whats-midias/Historico'),
        meta: { autenticacao: true, permissao: 'ROLE_VENDAS_VIA_WHATSAPP_E_MIDIAS_SOCIAIS' },
    },

    {
        path: 'pendencias',
        name: 'vendas-whats-midias-pendencias',
        component: () => import('@/aplicacao/modulos/vendas-whats-midias/Pendencias'),
        meta: { autenticacao: true, permissao: 'ROLE_VENDAS_VIA_WHATSAPP_E_MIDIAS_SOCIAIS_PENDENCIAS' },
    },

    {
        path: 'rascunhos',
        name: 'vendas-whats-midias-rascunhos',
        component: () => import('@/aplicacao/modulos/vendas-whats-midias/Rascunhos'),
        meta: { autenticacao: true, permissao: 'ROLE_VENDAS_VIA_WHATSAPP_E_MIDIAS_SOCIAIS_SOLICITAR' },
    },

    {
        path: 'formulario/:id?',
        name: 'vendas-whats-midias-formulario',
        component: () => import('@/aplicacao/modulos/vendas-whats-midias/Formulario'),
        meta: { autenticacao: true, permissao: 'ROLE_VENDAS_VIA_WHATSAPP_E_MIDIAS_SOCIAIS_SOLICITAR' },
    },

    {
        path: ':id',
        name: 'vendas-whats-midias-fluxo',
        component: () => import('@/aplicacao/modulos/vendas-whats-midias/Fluxo'),
        meta: { autenticacao: true, permissao: 'ROLE_VENDAS_VIA_WHATSAPP_E_MIDIAS_SOCIAIS' },
    },

    {
        path: 'relatorios/geral',
        name: 'vendas-whats-midias-relatorios-geral',
        component: () => import('@/aplicacao/modulos/vendas-whats-midias/relatorios/Geral'),
        meta: { autenticacao: true, permissao: 'ROLE_VENDAS_VIA_WHATSAPP_E_MIDIAS_SOCIAIS' },
    },

]
